// extracted by mini-css-extract-plugin
export var select = "_pf-0";